import { render, staticRenderFns } from "./activityProp.vue?vue&type=template&id=782c02b3&scoped=true&"
import script from "./activityProp.vue?vue&type=script&lang=js&"
export * from "./activityProp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "782c02b3",
  null
  
)

export default component.exports